import { configureStore } from '@reduxjs/toolkit';
import carriersReducer from '@redux/carrierSlices/carriersSlice';
import formsReducer from '@redux/carrierSlices/formSlice';
import vendorsReducer from '@redux/carrierSlices/vendorSlice';
import adminsReducer from '@redux/carrierSlices/adminSlice';
import ambestReducer from '@redux/carrierSlices/ambestSlice';
import agencyReducer from '@redux/brokerageSlices/agencySlice';
import configFieldsReducer from '@redux/brokerageSlices/configSlice';
import mobileAppsReducer from '@redux/brokerageSlices/mobileAppsSlice';
import membersReducer from '@redux/brokerageSlices/memberSlice';

const store = configureStore({
  reducer: {
    carriers: carriersReducer,
    forms: formsReducer,
    vendors: vendorsReducer,
    admins: adminsReducer,
    ambest: ambestReducer,
    agencies: agencyReducer,
    configFields: configFieldsReducer,
    mobileApps: mobileAppsReducer,
    members: membersReducer
  }
});

export default store;
